export function importSharerJs() {
  return new Promise((resolve, reject) => {
    if (window.Swiper) return resolve(window.Swiper);

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/sharer.js@0.5.2/sharer.min.js';
    script.onload = () => resolve(window.Swiper);
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

export function initSharrerWatch() {
  setInterval(() => {
    window.Sharer.init();
  }, 1000);
}
